<div class="container">
  <button
    mat-mini-fab
    color="primary"
    type="button"
    class="action-button file-download-button"
    [title]="'Download'"
    (click)="downloadFile()"
    [disabled]="isDisabled"
  >
    {{ buttonName }}
  </button>
</div>
